export default "__VITE_ASSET__CYx7KixF__"